<template>
    <NuxtLink
        :to="to"
        class="inline-flex items-center justify-center rounded-[999px] px-3 py-2.5 text-center text-[14px] leading-[1.15] transition-colors lg:rounded-[10px] lg:px-[30px] lg:text-[18px]"
        :class="selected ? 'bg-orange text-white' : 'bg-white text-gray-dark'"
        :aria-current="selected ? 'page' : undefined"
    >
        <slot />
    </NuxtLink>
</template>

<script lang="ts" setup>
defineProps<{
    to: string;
    selected?: boolean;
}>();
</script>
